import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { TASK_MOVE_TO_NEXT_DAY } from "../../../utils/config";
import Spinner from "../../Spinner";

export default function MoveActivityModal({showModal, setShowModal, removeActivity, activity}){
    const [movingActivity, setMovingActivity] = useState(false);    
    const [error, setError] = useState("");

    const handleClose = () => {
        setError("");
        setMovingActivity(false);
        setShowModal(false);
    }

    const moveActivity = () => {        
        setMovingActivity(true);
        setError("");

        const url = TASK_MOVE_TO_NEXT_DAY + activity.id;
        
        fetch(url, {
            method: "PUT",
            headers: {
                "Content-type": "application/json;charset=UTF-8",
                //'Authorization': localStorage.getItem("authorization")
            },
        })
        .then(response => {
            if(response.ok) return response.json();
            if(response.status===401) return {error: "Unauthorized"};
            if(response.status===404) return response.json();
            return Promise.reject(response);
        }).then(json => {           
            if(json?.error){
                setError(json.error);
                return;
            }   
            removeActivity(activity);
            handleClose();
        })
        .catch((response) =>{
            console.log("catch");
            console.log(response);
            setError("Ocurrió un error");
        }).finally(() =>{
            setMovingActivity(false);
        });  
    }

    if(activity == null){
        return null;
    }

    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Mover</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>¿Seguro que quieres mover la actividad <strong>{activity.content}</strong> al siguiente día hábil?</p>
                {
                    error && <div className="text-warning">{error}</div>
                }
            </Modal.Body>

            <Modal.Footer>
                {
                    movingActivity
                    ? <Button className="w-spinner" variant="warning" disabled>Moviendo <Spinner /></Button>
                    : 
                    <>
                        <Button variant="warning" onClick={moveActivity}>Mover</Button>
                        <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    );
}